import { usePhotos } from "./usePhotos.web";

export const useOverviewPhotos = (projectId: string, objectId: string) => {
  const [photos, isLoading] = usePhotos("overviewPhotos", projectId, objectId);

  return [photos, isLoading] as const;
};
